module.exports = __webpack_public_path__ + "img/cubo.c76c2e3f.svg";